import React from "react";

const PrintContext = React.createContext({
    setContext: (_context: any) => null,
    context: null,
});

export default PrintContext;
